import Actions from 'redux/actions'
import type { CallAPIAction, Status } from 'api/types'
import { FailResponse } from 'api/evisaAPI/dlAPI'
import { RejectIToIOfferResponse } from 'api/newDLTransferAPI'

type State = {} & Status

const initialState = {
  isLoading: false,
  success: false,
  fail: false,
}

export default (
  state: State = initialState,
  action: CallAPIAction<
    Actions.SEND_CV_REPORT_ASYNC,
    Actions.SEND_CV_REPORT_SUCCESS,
    Actions.SEND_CV_REPORT_FAIL,
    RejectIToIOfferResponse,
    FailResponse
  >,
): State => {
  switch (action.type) {
    case Actions.SEND_CV_REPORT_ASYNC:
    case Actions.SEND_CV_REPORT_SUCCESS:
    case Actions.SEND_CV_REPORT_FAIL: {
      return {
        ...state,
        ...action.status,
      }
    }

    default:
      return state
  }
}
